import classroom from '@/assets/img/users-cases/classroom.webp';
import classroomHow from '@/assets/img/users-cases/classroom-how.webp';
import classroomResult from '@/assets/img/users-cases/classroom-result.webp';

export default {
  slug: 'classroom',
  order: 23,
  title: '360 Classroom Tour',
  subtitle: 'Classroom layouts with clear 2D plans and 3D scenes',
  tags: ['EducationLayouts', 'Floorplans'],

  images: {
    hero: classroom,
    aboutTop: classroomHow,
    aboutBottom: classroomResult,
  },

  howText:
    'We developed 2D and 3D classroom floor plans and interior design solutions designed for both presentation and technical coordination.',

  resultText:
    'The ready-made plans help align stakeholders and simplify project discussions.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
